import { render, staticRenderFns } from "./detailPhone.vue?vue&type=template&id=71d3b3b1&scoped=true"
import script from "./detailPhone.vue?vue&type=script&lang=js"
export * from "./detailPhone.vue?vue&type=script&lang=js"
import style0 from "./detailPhone.vue?vue&type=style&index=0&id=71d3b3b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d3b3b1",
  null
  
)

export default component.exports